import { useNavigate, useLocation, useParams } from "react-router-dom";

function Router(Child) {
    function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return <Child {...props} {...{location, navigate, params}} />;
    }

    return ComponentWithRouterProp;
}

export default Router